import { Skeleton, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React from "react";
import he from 'he';

export default function QuoteBanner({data}){
    return(
        <Box
            sx={{
                backgroundImage:'url('+data?.image.url+')',
                backgroundSize:'cover',
                p:'3rem 0'
            }}
        >
            <Container maxWidth='xl'>
                <Box
                    sx={{
                        maxWidth:'500px',
                        backgroundColor:'rgba(256,256,245,0.9)',
                        p:'6rem 3rem 5rem 3rem',
                        ml:'auto'
                    }}
                >
                    <Box
                        sx={{
                            position:'relative',
                        }}
                    >
                        <Typography variant='p' component='p'
                            sx={{
                                fontSize:'1.2rem',
                                fontStyle:'italic',
                                fontWeight:600
                            }}
                        >
                            {data? he.decode(data.quote) : <Skeleton/>}
                        </Typography>
                            <Box
                            sx={{
                                position:'absolute',
                                top:'-3rem',
                                left:'-1rem'
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="85" height="auto" viewBox="0 0 119.602 86.563">
                                <path id="Path_8118" data-name="Path 8118" d="M26.763-198.044A50.483,50.483,0,0,1,32.854-221.3q6.091-11.812,23.071-33.038l14.027,10.521Q54.817-226.468,50.2-208.564a19.592,19.592,0,0,1,14.489,6.091,20.047,20.047,0,0,1,6,14.581,19.32,19.32,0,0,1-6,14.12,20.179,20.179,0,0,1-14.858,6,19.843,19.843,0,0,1-16.8-8.49Q26.763-184.755,26.763-198.044Zm75.674,0a50.483,50.483,0,0,1,6.091-23.256q6.091-11.812,23.071-33.038l13.843,10.521q-14.95,17.165-19.564,35.253a19.592,19.592,0,0,1,14.489,6.091,20.047,20.047,0,0,1,6,14.581,19.32,19.32,0,0,1-6,14.12,20.179,20.179,0,0,1-14.858,6,19.843,19.843,0,0,1-16.8-8.49Q102.437-184.755,102.437-198.044Z" transform="translate(-26.763 254.338)" fill="#e9531c" opacity="0.216"/>
                            </svg>
                        </Box>
                        <Box
                            sx={{
                                position:'absolute',
                                bottom:'-3rem',
                                right:'-1rem'
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="85" height="auto" viewBox="0 0 119.602 86.563">
                                <path id="Path_8117" data-name="Path 8117" d="M26.763-198.044A50.483,50.483,0,0,1,32.854-221.3q6.091-11.812,23.071-33.038l14.027,10.521Q54.817-226.468,50.2-208.564a19.592,19.592,0,0,1,14.489,6.091,20.047,20.047,0,0,1,6,14.581,19.32,19.32,0,0,1-6,14.12,20.179,20.179,0,0,1-14.858,6,19.843,19.843,0,0,1-16.8-8.49Q26.763-184.755,26.763-198.044Zm75.674,0a50.483,50.483,0,0,1,6.091-23.256q6.091-11.812,23.071-33.038l13.843,10.521q-14.95,17.165-19.564,35.253a19.592,19.592,0,0,1,14.489,6.091,20.047,20.047,0,0,1,6,14.581,19.32,19.32,0,0,1-6,14.12,20.179,20.179,0,0,1-14.858,6,19.843,19.843,0,0,1-16.8-8.49Q102.437-184.755,102.437-198.044Z" transform="translate(146.364 -167.774) rotate(180)" fill="#e9531c" opacity="0.216"/>
                            </svg>
                        </Box>
                    </Box>
                    <Typography
                        sx={{
                            mt:'1rem',
                            fontSize:'1.2rem'
                        }}
                    >
                        {data? data.attribution : <Skeleton/>}
                    </Typography>
                    <img
                        src={data?.logo.url}
                        width='80px'
                        style={{
                            marginTop:'1rem'
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
}